module.exports = __webpack_public_path__ + "img/driver.cbaab76b.png";